/**
 * The customer's Anthropic key, opt-in persisted (SD-3, BENCH-UX-SPEC §1). `localStorage` only, as-is, no expiry; every
 * call is best effort (storage can be missing in a private window).
 */
const KEY = 'provenance.apiKey';

export function loadRememberedKey(): string | null {
	try {
		return localStorage.getItem(KEY);
	} catch {
		return null;
	}
}

export function rememberKey(key: string): void {
	try {
		localStorage.setItem(KEY, key);
	} catch {
		/* storage unavailable: the key still lives in the session's app state */
	}
}

export function forgetKey(): void {
	try {
		localStorage.removeItem(KEY);
	} catch {
		/* nothing stored, nothing to remove */
	}
}

/** The human-reference categories the viewer chose (UD-24): a per-viewer convenience, best effort. */
const STRATA_KEY = 'provenance.humanStrata';

export function loadHumanStrata(): string[] | null {
	try {
		const raw = localStorage.getItem(STRATA_KEY);
		if (raw === null) return null;
		const v: unknown = JSON.parse(raw);
		return Array.isArray(v) && v.every((x) => typeof x === 'string') ? v : null;
	} catch {
		return null;
	}
}

export function saveHumanStrata(ids: readonly string[]): void {
	try {
		localStorage.setItem(STRATA_KEY, JSON.stringify(ids));
	} catch {
		/* storage unavailable: the choice lasts for this page */
	}
}

/** Whether the overview's "How to read these numbers" section is open (UD-33): a per-viewer convenience, open by default. */
const READING_KEY = 'provenance.overviewReading';

export function loadReadingOpen(): boolean {
	try {
		return localStorage.getItem(READING_KEY) !== 'hidden';
	} catch {
		return true;
	}
}

export function saveReadingOpen(open: boolean): void {
	try {
		if (open) localStorage.removeItem(READING_KEY);
		else localStorage.setItem(READING_KEY, 'hidden');
	} catch {
		/* storage unavailable: the choice lasts for this page */
	}
}
